export default "__VITE_ASSET__D7u41Hnz__"